/**
 * @version:               1.0.0
 * @createTime:            2021.10.09
 * @updateTime:            2021.10.09
 * @author:                zhangju
 * @description
 ***/

export default {
    name: 'zt-detail',
    data() {
        return {
            crumbsList: [],
            id: '',
            title:'',
            fbsj: '',
            fbdw: '',
            data: {ztlmVOList:[]}
        };
    },
    mounted() {
        this.init();
    },
    watch:{
        '$route.query.id':{
            handler() {
                this.changeCrumb();
            },
            immediate:true
        }
    },
    methods: {
        init() {
            this.changeCrumb();
            this.getData();
        },
        changeCrumb() {
            this.id = this.$route.query.id;
            this.title = this.$route.query.bt;
            this.fbsj = this.$route.query.fbsj;
            this.fbdw = this.$route.query.fbdw;
            this.crumbsList = [{
                name:'审判研究',
                key:'hsal',
                path: '/hsal'
            }, {
                name:this.title,
                key:  this.id
            }];
        },
        // 获取专题的文章
        getData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.zt.ztMessage.replace('{ztid}', this.id)
            }).then((res) => {
                this.data = res.data;
            });
        },
        // 查看更多
        handleMore(item) {
            this.$router.push({
                path: '/zt/more',
                query: {
                    lmid: item.ztlm.bh,
                    ztid:this.id,
                    fbsj: this.fbsj,
                    fbdw: this.fbdw,
                    lmmc: item.ztlm.lmmc,
                    ztmc:this.title
                }
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/zt/xq', query: {active:'zt', id:item.bh, fbsj: this.fbsj, fbdw: this.fbdw}});
            window.open(url.href, '_blank');
        }
    }
};
